export const order_form = {
  data() {
    var validateValidDate = (rule, value, callback) => {
      if (!value || !this.data.order_date) {
        callback();
        return;
      }
      if (value < this.data.order_date) {
        callback(new Error("발주일보다 빠릅니다."));
      } else {
        callback();
      }
    };
    return {
      sum: 0,
      form_data: undefined,
      customer: undefined,
      rules: {
        customer_id: [{ required: true, message: "거래처를 선택해 주세요." }],
        order_date: [{ required: true, message: "발주일을 선택해 주세요." }],
        valid_date: [
          { required: true, message: "납기일을 선택해 주세요." },
          { validator: validateValidDate, trigger: ["blur", "change"] }
        ]
      }
    };
  },
  computed: {
    isNew: function() {
      return this.data.id < 1;
    },
    disabled() {
      return !this.data.customer_id;
    },
    isOrder() {
      if (this.isNew) { return false; }
      let item = this.data.details.find(d => d.status_flag && d.status_flag !== '0');
      return !!item;
    },
    activeResisterButton() {
      if (this.data.customer_id && this.sum !== 0 ) { return false; }
      return true;
    },
    invalid_details() {
      let invalid_index = [];
      this.getDetails().forEach((d, index) => {
        if (d.product_name && !d.product_id) {
          return invalid_index.push(index+1);
        }
      });
      return invalid_index;
    },
    checkStatusFlag() {
      if (this.data.details === undefined) {
        return false;
      } else {
        if (this.data.details.length < 1) return false;
        else if (!this.data.details[0].status_flag 
                || this.data.details[0].status_flag === '0') return false;
        else return true;
      }
    },
  },
  methods: {
    initData() {
      return {
        id: 0,
        code: "",
        customer_id: 0,
        order_date: this.util.getDate(0),
        valid_date: this.util.getDate(1),
        charge_id: null,
        customer_charger: "",
        location: "",
        customer_name: "",
        status_flag: "N",
        tel: "",
        fax: "",
        price: 0,
        cost: 0,
        owner: "",
        details: []
      };
    },
    getDetails() {
      const trades = this.$refs.trade.result();
      const details = [];
      //let product_name = '';
      for (let i = 0; i < trades.length; i++) {
        if (!trades[i].product_id && !trades[i].amount) {
          continue;
        }
        if (!trades[i].cost) { trades[i].cost = null; }
        if (!trades[i].supply_price) { trades[i].supply_price = null; }
        if (!trades[i].tax) { trades[i].tax = null; }
        let detail = Object.assign({}, trades[i]);
        if (!detail.price) { detail.price = 0 }
        detail.seq = i + 1;        
        details.push(detail);
      }      
      return details;
    },  
    handleSelectCustomer(c) {
      if (typeof c === "string") {
        this.data.customer_id = null;
        this.data.customer_name = c;        
        this.customer = null;
      } else {
        this.data.customer_id = c.id;
        this.data.customer_name = c.name;        
        this.customer = c;
      }
    },
    handleChangedSum(sum) {
      this.sum = sum;
    },
    handleClickClear() {
      // this.$refs.trade.clear();
      this.data.id = 0;
      this.data.contract_date = this.util.getDate(0);
      this.data.delivery_date = this.util.getDate(30);
      this.data.details = [];
    },
  }
}